import React, { useState } from "react";
import { connect } from "react-redux";
import PrivacyPolicy from "../../Modules/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../../Modules/TermsAndConditions/TermsAndConditions";
import Modal from "@instream-solutions/instream-design-system/lib/UX/Modal/Modal";
import { Typography, Grid } from "@mui/material";
import { getHighlightColor } from "../../../common/shared";
import Helmet from "react-helmet";

function Footer(props) {
  const [state, setState] = useState({
    showPrivacyPolicy: false,
    showTermsAndConditions: false,
  });

  setTimeout(() => {
    if (window.zE) {
      window.zE("webWidget", "updateSettings", {
        webWidget: {
          color: { theme: getHighlightColor(props.highlightColor) },
          offset: { vertical: "35px" },
        },
      });
    }
  }, 500);

  return (
    <React.Fragment>
      <div className={"instream-footer"}>
        <Typography className={"signin-patent-pending"}>
          &copy; 2023 Engage. A division of WealthCentral. All Rights Reserved.
        </Typography>
        <ul className={"signin-page-footer"}>
          <li>
            <a href="https://vestevo.zendesk.com/hc/en-us" target={"_blank"}>
              Support
            </a>
          </li>
          <li>
            <a
              href={"#"}
              onClick={() => {
                setState({
                  ...state,
                  showPrivacyPolicy: true,
                });
              }}
            >
              Privacy Policy
            </a>
          </li>
          <li>
            <a
              href={"#"}
              onClick={() => {
                setState({
                  ...state,
                  showTermsAndConditions: true,
                });
              }}
            >
              Terms of Service
            </a>
          </li>
        </ul>
      </div>
      {state.showPrivacyPolicy && (
        <Modal
          onCancel={() => {
            setState({
              ...state,
              showPrivacyPolicy: false,
            });
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} className={"modal-info-container"}>
              <PrivacyPolicy
                onClose={() => {
                  setState({
                    ...state,
                    showPrivacyPolicy: false,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Modal>
      )}
      {state.showTermsAndConditions && (
        <Modal
          onCancel={() => {
            setState({
              ...state,
              showTermsAndConditions: false,
            });
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} className={"modal-info-container"}>
              <TermsAndConditions
                onClose={() => {
                  setState({
                    ...state,
                    showTermsAndConditions: false,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Modal>
      )}
      {/*      <Helmet>
        <script
          id="ze-snippet"
          src="https://static.zdassets.com/ekr/snippet.js?key=6e00e280-00e6-480b-b302-c5417a5ea00f"
        >
          {" "}
        </script>
      </Helmet>*/}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    highlightColor: state.uxStateReducer.getIn([
      "appearance",
      "highlightColor",
    ]),
  };
};

export default connect(mapStateToProps)(Footer);
